if (!customElements.get("s-scrolling-promotion")) {
    class ScrollingPromotion extends HTMLElement {
      constructor() {
        super();
        this.glide = null;
        this.isAutoScrolling = false;
        this.originalDirection = 'left';
      }
  
      connectedCallback() {
        // Defer initialization to ensure all child nodes from Liquid are parsed and available.
        setTimeout(this.init.bind(this), 0);
      }
  
      init() {
        this.promotion = this.querySelector(".s-promotion");
        if (!this.promotion) {
          console.error("Scrolling Promotion: .s-promotion container not found.");
          return;
        }
        
        this.originalDirection = this.dataset.direction || 'left';
  
        this.checkAutoScroll();
  
        // Ensure GlideJS is loaded
        if (typeof Glide === 'undefined') {
          console.log("Glide not ready, retrying...");
          setTimeout(this.init.bind(this), 100);
          return;
        }
        
        this.setupGlide();
      }
  
      setupGlide() {
        this.convertToGlideStructure();
  
        const slides = this.querySelectorAll('.glide__slide');
        if (slides.length === 0) {
          console.error("Scrolling Promotion: No slides found to initialize Glide.");
          return;
        }
  
        const style = getComputedStyle(this.closest('.s-section'));
        const itemsPerRow = parseInt(style.getPropertyValue('--items-per-row')) || 7;
        const speed = parseInt(style.getPropertyValue('--duration').replace('s', '')) * 1000 || 4000;
  
        const glideOptions = {
          type: 'carousel',
          perView: itemsPerRow,
          gap: 0,
          direction: this.originalDirection === 'right' ? 'rtl' : 'ltr',
          hoverpause: true,
          keyboard: true,
          animationDuration: 800,
          breakpoints: {
            1024: { perView: Math.min(5, itemsPerRow) },
            768: { perView: Math.min(3, itemsPerRow) },
            480: { perView: 2 }
          }
        };
  
        if (this.isAutoScrolling) {
          glideOptions.autoplay = speed;
        }
  
        try {
          this.glide = new Glide(this, glideOptions);
          this.glide.mount();
          this.setupNavigationArrows(); // Setup arrows after mount
          console.log('Glide initialized successfully');
        } catch (error) {
          console.error('Error initializing Glide:', error);
        }
      }
  
      convertToGlideStructure() {
        this.classList.add('glide');
  
        const track = document.createElement('div');
        track.className = 'glide__track';
        track.setAttribute('data-glide-el', 'track');
  
        const slidesWrapper = document.createElement('ul');
        slidesWrapper.className = 'glide__slides';
  
        Array.from(this.promotion.children).forEach(item => {
          if (item.nodeType === 1) {
            const slide = document.createElement('li');
            slide.className = 'glide__slide';
            slide.appendChild(item);
            slidesWrapper.appendChild(slide);
          }
        });
  
        track.appendChild(slidesWrapper);
        this.promotion.replaceWith(track);
      }
  
      setupNavigationArrows() {
        const showArrows = this.dataset.showArrows === 'true';
        if (!showArrows || !this.glide) return;
  
        const parentSection = this.closest('.s-section');
        if (!parentSection) return;
  
        const prevButton = parentSection.querySelector('.s-slider-controls__button-prev');
        const nextButton = parentSection.querySelector('.s-slider-controls__button-next');
  
        if (prevButton) {
          prevButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.glide.go('<');
          });
        }
  
        if (nextButton) {
          nextButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.glide.go('>');
          });
        }
      }
  
      checkAutoScroll() {
        this.isAutoScrolling = this.dataset.autoScroll === 'true';
      }
    }
  
    customElements.define("s-scrolling-promotion", ScrollingPromotion);
  }